// import { emotesList } from "../utils";
import Image from "_components/atoms/image";

import useStyles from "./styles/chatText";

const ChatText = ( { text, emotesList } ) => {

	const { classes } = useStyles ( undefined, { name: "styles" } );

	if ( !text )
		return null;

	text = " " + text;

	return text.split ( /:/g ).map ( ( elem, i ) => {
		if ( !elem )
			return null;
		if ( !emotesList?.[elem] )
			return elem;

		return (
			<div
				key = { i }
				className = { classes.emoteContainer }
			>
				<Image
					useOriginal
					className = { classes.emote }
					quality = { 100 }
					src = { emotesList[elem].url }
				/>
			</div>
		);
	} );
};

export default ChatText;
